import addStartupScript from './events/addStartupScript';
import {ItemSearch} from './item_search';
import 'custom-event-polyfill';

/**
 * Use js-events to track search activity
 * trackSearch.
 *
  * @param {object} searchParams Details of search
 */
const trackSearch = (searchParams) => {
  // const target = 'course_search';
  // const category = 'atlas';

  // temporarily disabling tracking
  // track('search', Object.assign({}, { target, category, ...searchParams }));
};

/**
  * Class that wraps the ElasticAppSearch interface
  */

export default class CourseSearch {
  constructor(engine, pageSize = 24) {
    
    this.client = ItemSearch.createClient(engine);

    this.defaults = {
      page: { size: pageSize },
      filters: ''
    };
  }

  /*
    * Raise event with results for anyone that wants it
    *
    * @param {object} ResultList object from ElasticAppSearch
    */
  _raiseEvent(eventName, data) {
    const event = new CustomEvent(eventName, { detail: data });
    document.dispatchEvent(event);
  }

  /**
    * Fetch facets for a search interface
    *
    * @param {object} options object to override defaults
    */
  fetchFacets(options) {
    const opts = Object.assign({}, this.defaults, options);
    this.client.facets('', opts)
      .then(resultList => {
        this._raiseEvent('facetsComplete', resultList.info.facets);
      });
  }

  /**
    * Execute the search
    * @param {string} search term to search for
    * @param {object} options object to override defaults
    * @param {string} id of the target element for the search results
    */
  search(query, options, targetId) {
    const opts = Object.assign({}, this.defaults, options);
    this.client.search(query, opts)
      .then(({ rawResults, rawInfo }) => {
        const { page } = rawInfo.meta;

        const result_uuids = rawResults
          .map(rawResult => rawResult.id);

        const filters = opts.filters.all
          .map(filter => {
            if (filter.any && Array.isArray(filter.any)) {
              return filter.any.map(filter_item => {
                return Object.entries(filter_item).map(([key, value]) => {
                  if (typeof(value) === 'object') {
                    return Object.entries(value).map(([subkey, value]) => ({
                      [`${key}_${subkey}`]: value
                    }));
                  }
                  return { [key]: value };
                }).flat();
              }).flat();
            }
            return filter;
          }).flat();

        trackSearch({ query, filters, page, result_uuids });
        return this._raiseEvent('searchComplete', { rawResults, rawInfo, targetId });
      });
  }
}

export function setup(){
  if (window.courseSearchDefaults) {
    window.courseSearchDefaults.forEach(entry => {
      const { targetId, options: { engine, filters, page, query, min_score } } = entry;
      const searchClient = new CourseSearch(engine);
      searchClient.search(query, {filters, page, min_score}, targetId);
    });
  }
}

addStartupScript(setup);
